import ApiClient from '@/helpers/api/api.helpers';
import axios from '@/helpers/api/HTTPClient.helper.js';

class CallerInfo extends ApiClient {
  constructor() {
    super('iam/workspaces/caller-info');
  }

  getCallerInfo(resource) {
    return axios.get(`${this.url}/${resource}`);
  }
}

export default new CallerInfo();
